import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

import { capitalize } from 'common/utils/capitalize';

const Status = ({ children, hasCashbackInfo = false, status }) => (
  <>
    <div className="cashback__item__row">
      <span className="sub-title-text">
        <Label message="status" />:
      </span>
      <span className="title-small-text">{capitalize(status)}</span>
    </div>
    <div className="cashback__activated">
      {hasCashbackInfo && (
        <Label className="cashback__activated__text" message="cashback_active_text" />
      )}
      {children}
    </div>
  </>
);

Status.propTypes = {
  children: PropTypes.node.isRequired,
  hasCashbackInfo: PropTypes.bool,
  status: PropTypes.string.isRequired,
};

export default Status;
